// eslint-disable-next-line import/no-cycle, camelcase
// import jwt_decode from 'jwt-decode'
// eslint-disable-next-line import/no-cycle
import router from '../../../router'
import jwtDefaultConfig from '../../jwtDefaultConfig'
import urls from '../../url'

export default class JwtService {
  // Will be used by this service for making API calls
  axiosIns = null

  // jwtConfig <= Will be used by this service
  jwtConfig = { ...jwtDefaultConfig }

  // For Refreshing Token
  isAlreadyFetchingAccessToken = false

  // For Refreshing Token
  subscribers = []

  refreshTask = null

  constructor(axiosIns, jwtOverrideConfig) {
    this.axiosIns = axiosIns
    this.jwtConfig = { ...this.jwtConfig, ...jwtOverrideConfig }
    // Request Interceptor
    this.axiosIns.interceptors.request.use(
      config => {
        // Get token from localStorage
        const accessToken = this.getToken()
        // If token is present add it to request's Authorization Header
        if (accessToken) {
          // eslint-disable-next-line no-param-reassign
          config.headers.Authorization = `${this.jwtConfig.tokenType} ${accessToken}`
        }
        return config
      },
      error => Promise.reject(error),
    )

    // Add request/response interceptor
    this.axiosIns.interceptors.response.use(
      response => response,
      // eslint-disable-next-line consistent-return
      async error => {
        // const { config, response: { status } } = error
        const { config, response } = error
        const originalRequest = config
        if (response.status === 401 && originalRequest.url.includes('user/refresh')) {
          this.logout()
          return Promise.reject(error)
        // eslint-disable-next-line no-underscore-dangle
        } if (response.status === 401 && !originalRequest._retry) {
          // eslint-disable-next-line no-underscore-dangle
          originalRequest._retry = true
          await this.refreshTokens()
          const accessToken = this.getToken()
          originalRequest.headers.Authorization = `${this.jwtConfig.tokenType} ${accessToken}`
          return this.axiosIns(originalRequest)
        }
        return Promise.reject(error)
      },
    )
  }

  onAccessTokenFetched(accessToken) {
    this.subscribers = this.subscribers.filter(callback => callback(accessToken))
  }

  addSubscriber(callback) {
    this.subscribers.push(callback)
  }

  getToken() {
    return localStorage.getItem(this.jwtConfig.storageTokenKeyName)
  }

  getRefreshToken() {
    return localStorage.getItem(this.jwtConfig.storageRefreshTokenKeyName)
  }

  setToken(value) {
    localStorage.setItem(this.jwtConfig.storageTokenKeyName, value)
  }

  async refreshTokens() {
    await this.refreshToken()
      .then(r => {
        this.isAlreadyFetchingAccessToken = false
        // Update accessToken in localStorage
        this.setToken(r.data.token)
        this.setRefreshToken(r.data.refreshToken)
        this.onAccessTokenFetched(r.data.accessToken)
      })
      .catch(e => {
        console.log(e)
        this.logout()
      })
  }

  setRefreshToken(value) {
    localStorage.setItem(this.jwtConfig.storageRefreshTokenKeyName, value)
  }

  // eslint-disable-next-line class-methods-use-this
  setSiteRoutes(value) {
    localStorage.setItem('siteRoutes', value)
  }

  login(...args) {
    return this.axiosIns.post(urls.loginEndpoint, ...args)
  }

  clearUserData() {
    localStorage.removeItem(this.jwtConfig.storageTokenKeyName)
    localStorage.removeItem(this.jwtConfig.storageRefreshTokenKeyName)
    localStorage.removeItem('siteRoutes')
    // Remove userData from localStorage
    localStorage.removeItem('userData')
  }

  logout() {
    // Remove userData from localStorage
    // ? You just removed token from localStorage. If you like, you can also make API call to backend to blacklist used token
    localStorage.removeItem(this.jwtConfig.storageTokenKeyName)
    localStorage.removeItem(this.jwtConfig.storageRefreshTokenKeyName)
    localStorage.removeItem('siteRoutes')
    // Remove userData from localStorage
    localStorage.removeItem('userData')

    // Redirect to login page
    router.push({ name: 'auth-login' })
  }

  register(...args) {
    return this.axiosIns.post(urls.registerEndpoint, ...args)
  }

  async refreshToken() {
    return this.axiosIns.post(urls.refreshEndpoint, {
      refreshToken: this.getRefreshToken(),
    })
  }
}
